module.exports = __webpack_public_path__ + "cement/img/组 23265@2x.e3ba977a.png";